import React from "react";

function YoutubeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#FF0209"
        d="M24.625 12.659c0-6.63-5.373-12.004-12-12.004s-12 5.374-12 12.004 5.373 12.003 12 12.003 12-5.374 12-12.003z"
      ></path>
      <path
        fill="#fff"
        d="M17.719 17.975a9.792 9.792 0 01-1.075.045l-8.208-.007c-.86 0-1.798-.028-2.464-.575-.75-.618-.905-1.69-.966-2.66a34.66 34.66 0 01-.022-3.994c.038-.73.105-1.478.42-2.14.225-.474.602-.901 1.084-1.126.561-.26 1.148-.214 1.752-.215l4.336-.004 4.508-.004c.71 0 1.473.014 2.052.425.748.53.951 1.538 1.045 2.45.173 1.679.175 3.376.006 5.055-.07.693-.186 1.425-.642 1.95-.452.522-1.122.722-1.826.8z"
      ></path>
      <path
        fill="#FF0209"
        d="M15.072 12.659l-4.078-2.355v4.71l4.078-2.355z"
      ></path>
    </svg>
  );
}

export default YoutubeIcon;
